export class UsageTypeFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "_in",
            "baseName": "in",
            "type": "Array<UsageType>",
            "format": ""
        },
        {
            "name": "notIn",
            "baseName": "notIn",
            "type": "Array<UsageType>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UsageTypeFilters.attributeTypeMap;
    }
    constructor() {
    }
}
